import React from "react";

const KeyIcon = (props: React.ComponentProps<"svg">) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5002 1.66602L15.8336 3.33268M15.8336 3.33268L18.3336 5.83268L15.4169 8.74935L12.9169 6.24935M15.8336 3.33268L12.9169 6.24935M9.4919 9.67435C9.92218 10.0989 10.2642 10.6044 10.4984 11.1617C10.7325 11.719 10.8541 12.3171 10.8561 12.9215C10.8581 13.526 10.7405 14.1249 10.5102 14.6838C10.2798 15.2426 9.94111 15.7504 9.51368 16.1778C9.08625 16.6052 8.5785 16.9439 8.01965 17.1743C7.4608 17.4047 6.8619 17.5222 6.25742 17.5202C5.65295 17.5182 5.05485 17.3966 4.49755 17.1625C3.94026 16.9284 3.43478 16.5863 3.01023 16.156C2.17534 15.2916 1.71336 14.1338 1.72381 12.9321C1.73425 11.7304 2.21627 10.5808 3.06606 9.73101C3.91585 8.88123 5.0654 8.3992 6.26714 8.38876C7.46888 8.37832 8.62664 8.84029 9.49106 9.67518L9.4919 9.67435ZM9.4919 9.67435L12.9169 6.24935"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KeyIcon;
